/* Cap gallery height to image proportions; svh avoids Safari toolbar jumps. */
(() => {
 const row = document.querySelector('#header-component .header__row--top');
 if (!row || !document.documentElement.classList.contains('fate-mobile-gallery')) return;
 const photos = [...document.querySelectorAll('.product-information__media slideshow-slide .product-media__image')];
 const ratios = photos.map(img => Number(img.getAttribute('width')) / Number(img.getAttribute('height'))).filter(ratio => Number.isFinite(ratio) && ratio > 0);
 if (ratios.length) document.documentElement.style.setProperty('--fate-photo-ratio',String(Math.max(...ratios)));
})();
